<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from ".";

const props = defineProps({
  variant: {
    type: String,
    default: "default",
  },
  size: {
    type: String,
    default: "default",
  },
  as: {
    type: String,
    default: "button",
  },
  type: {
    type: String,
    default: "button",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  class: {
    type: String,
    default: "",
  },
});

const nativeType = computed(() => (props.as === "button" ? props.type : null));

const classes = computed(() =>
  cn(
    buttonVariants({
      variant: props.variant,
      size: props.size,
    }),
    props.class
  )
);
</script>

<template>
  <component :is="as" :type="nativeType" :class="classes" :disabled="disabled">
    <slot />
  </component>
</template>
